import { apiPost, parseJsonResponse } from './apiClient';
import { setToken } from '../helpers';

export const login = async (identifier, password) => {
  const response = await apiPost('/auth/local', { identifier, password });
  const data = await parseJsonResponse(response);
  if (data?.error) throw data.error;
  setToken(data.jwt);
  return data.user;
};

export const changePassword = async (currentPassword, password, passwordConfirmation) => {
  const response = await apiPost('/auth/change-password', {
    currentPassword,
    password,
    passwordConfirmation,
  });
  const data = await parseJsonResponse(response);
  if (data?.error) throw data.error;
  return data;
};

export const forgotPassword = async (email) => {
  const response = await apiPost('/auth/forgot-password', { email });
  const data = await parseJsonResponse(response);
  if (data?.error) throw data.error;
  return data;
};
